import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/index';

const initialState = {};

const devTools =  window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : x => x;

const store  = createStore(
  rootReducer,
  initialState,
  compose(
  applyMiddleware(thunk),
  devTools
  )
);

export default store;
